<template>
    <q-btn-toggle
        :model-value="modelValue"
        :options="options"
        :toggle-color="yesNoNaColors[modelValue]"
        clearable
        no-caps
        @update:model-value="$emit('update:modelValue', $event)"
    />
</template>

<script setup>
import { useAppStore } from 'src/stores/appStore.js'
import { yesNoNaIcons } from 'src/utils/icons.js'
import { yesNoNaColors } from 'src/utils/colors.js'
import { computed } from 'vue'

defineProps({ modelValue: Number })
defineEmits(['update:modelValue'])

const appStore = useAppStore()

const options = computed(() => {
    return appStore.lookups.yes_no_options.map(option => ({
        label: trans(option.value),
        value: option.id,
        icon: yesNoNaIcons[option.id],
    }))
})
</script>
